function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i["return"] && (_r = _i["return"](), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import React, { useState, useEffect } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { Button, Space, Table, message, Drawer, Modal, Select, Form, DatePicker, Divider, notification } from 'antd';
import Common from '../components/includes/Common';
import { CashCoin } from 'react-bootstrap-icons';
import OrderListView from '../components/OrderListView';
import moment from "moment";
import PumpReportList from '../components/PumpReportsList';
import CashTransactionHistory from '../components/CashTransactionHistory';
import AddTransaction from '../components/forms/AddTransaction';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
var RangePicker = DatePicker.RangePicker;
var Cashier = function Cashier() {
  var _useState = useState([]),
    _useState2 = _slicedToArray(_useState, 2),
    providersList = _useState2[0],
    setProvidersList = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    isDataChanged = _useState4[0],
    setIsDataChanged = _useState4[1];
  var _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    isDataLoading = _useState6[0],
    setIsDataLoading = _useState6[1];
  var _useState7 = useState(false),
    _useState8 = _slicedToArray(_useState7, 2),
    isNewTransactionOpen = _useState8[0],
    setIsNewTransactionOpen = _useState8[1];
  var _useState9 = useState(null),
    _useState10 = _slicedToArray(_useState9, 2),
    operationType = _useState10[0],
    setOperationType = _useState10[1];
  var _useState11 = useState([]),
    _useState12 = _slicedToArray(_useState11, 2),
    stationsOptions = _useState12[0],
    setStationsOptions = _useState12[1];
  var _useState13 = useState(null),
    _useState14 = _slicedToArray(_useState13, 2),
    selectedStationId = _useState14[0],
    setSelectedStationId = _useState14[1];
  var _useState15 = useState(null),
    _useState16 = _slicedToArray(_useState15, 2),
    selectedStation = _useState16[0],
    setSelectedStation = _useState16[1];
  var _useState17 = useState([]),
    _useState18 = _slicedToArray(_useState17, 2),
    stationsList = _useState18[0],
    setStationsList = _useState18[1];
  var _useState19 = useState([]),
    _useState20 = _slicedToArray(_useState19, 2),
    cashboxBalance = _useState20[0],
    setCashboxBalance = _useState20[1];
  var _Form$useForm = Form.useForm(),
    _Form$useForm2 = _slicedToArray(_Form$useForm, 1),
    form = _Form$useForm2[0];
  var onOrderSearchFinish = function onOrderSearchFinish(value) {};
  var handleStationChange = function handleStationChange(v) {
    setSelectedStationId(v);
    setIsDataChanged(true);
  };
  var getAllData = function getAllData() {
    //let sid = Common.currentStation == 'undefined' ? null : Common.currentStation.id ; 
    axios.all([axios.get(Common.baseApiUrl + 'getproviders/' + Common.currentStation.id + '/' + Common.currentUser.id.toString()), axios.get(Common.baseApiUrl + "getcashboxbalance/" + Common.currentStation.id + "/" + Common.currentUser.id)]).then(function (response) {
      setIsDataLoading(true);
      if (response[0].data.status == 200) {
        setProvidersList([]);
        response[0].data.providers.forEach(function (p) {
          setProvidersList(function (prev) {
            return [].concat(_toConsumableArray(prev), [{
              key: p.id,
              label: p.label,
              balance: p.balance,
              mail: p.mail,
              gas_station: p.gas_station.label,
              provider: p
            }]);
          });
        });
      } else {
        message.error({
          content: response[0].data.message,
          delay: 4
        });
      }
      if (response[1].data.status == 200) {
        setCashboxBalance(response[1].data.balance);
      } else {
        notification.error({
          message: "Erreur!",
          description: "Une érreur est survenue"
        });
      }
    })["catch"](function (error) {
      message.error({
        content: "Une erreur est survenue",
        delay: 4
      });
    })["finally"](function () {
      setIsDataLoading(false);
    });
  };
  useEffect(function () {
    getAllData();
  }, [isDataChanged, selectedStationId]);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsxs(Container, {
      children: [/*#__PURE__*/_jsxs(Row, {
        children: [/*#__PURE__*/_jsx(Col, {
          lg: 8,
          md: 8,
          children: /*#__PURE__*/_jsxs(Space, {
            direction: "horizontal",
            wrap: true,
            children: [/*#__PURE__*/_jsx(Button, {
              type: "link",
              size: "middle",
              onClick: function onClick() {
                setOperationType(1);
                setIsNewTransactionOpen(true);
              },
              children: /*#__PURE__*/_jsxs("b", {
                children: [/*#__PURE__*/_jsx(CashCoin, {
                  size: 20
                }), " ENTREE DE CAISSE"]
              })
            }), /*#__PURE__*/_jsx(Button, {
              type: "link",
              size: "middle",
              onClick: function onClick() {
                setOperationType(0);
                setIsNewTransactionOpen(true);
              },
              children: /*#__PURE__*/_jsxs("b", {
                children: [/*#__PURE__*/_jsx(CashCoin, {
                  size: 20
                }), " SORTIE DE CAISSE"]
              })
            })]
          })
        }), /*#__PURE__*/_jsx(Col, {
          lg: {
            span: 3,
            offset: 1
          },
          md: {
            span: 3,
            offset: 1
          },
          children: Common.currentStation != 'undefined' && Common.currentStation.cash_box && /*#__PURE__*/_jsx("div", {
            style: {
              boxShadow: 'rgba(0, 0, 0, 0.1) 0px 1px 3px 0px, rgba(0, 0, 0, 0.06) 0px 1px 2px 0px',
              textAlign: "center",
              padding: "14px",
              borderRadius: "6px",
              background: "#FFF8E7"
            },
            children: /*#__PURE__*/_jsxs("h4", {
              children: [/*#__PURE__*/_jsx("b", {
                children: /*#__PURE__*/_jsx(CashCoin, {
                  size: 22
                })
              }), " ", cashboxBalance.toLocaleString('Fr'), " GNF"]
            })
          })
        })]
      }), /*#__PURE__*/_jsx(Row, {
        children: /*#__PURE__*/_jsxs(Col, {
          lg: 12,
          children: [/*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("h5", {
            children: /*#__PURE__*/_jsx("b", {
              children: "RAPPORTS DE POMPISTES"
            })
          }), Common.currentStation != 'undefined' && /*#__PURE__*/_jsx(PumpReportList, {
            refresh: function refresh() {
              setIsDataChanged(true);
            },
            cashBox: Common.currentStation.cash_box
          }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("h5", {
            children: /*#__PURE__*/_jsx("b", {
              children: "ENTREES/SORTIES DE CAISSE"
            })
          }), Common.currentStation != 'undefined' && /*#__PURE__*/_jsx(CashTransactionHistory, {
            cashBox: Common.currentStation.cash_box
          })]
        })
      })]
    }), operationType != null && /*#__PURE__*/_jsx(Modal, {
      open: isNewTransactionOpen,
      destroyOnClose: true,
      onCancel: function onCancel() {
        setIsNewTransactionOpen(false);
      },
      title: /*#__PURE__*/_jsxs("b", {
        children: ["NOUVELLE ", operationType == 0 ? "SORTIE" : "ENTREE", " DE CAISSE"]
      }),
      footer: null,
      children: /*#__PURE__*/_jsx(AddTransaction, {
        operationType: operationType,
        cashBox: Common.currentStation.cash_box,
        gasStationId: Common.currentStation.id,
        handler: function handler() {
          setIsDataChanged(true), setIsNewTransactionOpen(false);
          message.success({
            content: 'Transaction enregistrée !'
          });
        }
      })
    })]
  });
};
export default Cashier;